export const useStorage = () => {
  const storage = JSON.parse(localStorage.getItem("layer") ?? "0");

  const setStorage = (layer: number) => {
    localStorage.setItem("layer", JSON.stringify(layer));
  };

  return { storage, setStorage };
};
